module.exports = __webpack_public_path__ + "static/media/Stellar Neo Single Headboard - 120 cm_Light Beige.6fb0f6fc.png";